var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMentions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5164 35.6263C19.9437 31.9114 26.2404 31.8334 30.8938 35.0346L49.4582 19.4572C50.9188 18.2317 53.1435 18.4569 54.4036 19.9586C55.618 21.4059 55.5084 23.5311 54.1899 24.7796L58.1341 29.4801C59.3939 30.9815 59.23 33.2115 57.7692 34.4373C56.3086 35.6629 54.0839 35.4376 52.8238 33.9359L48.884 29.2406L46.4246 31.3043L48.7313 34.0534C49.9912 35.5547 49.8273 37.7848 48.3664 39.0106C46.9059 40.2362 44.6812 40.0109 43.4211 38.5092L41.1144 35.7601L35.475 40.4922C37.8195 45.6307 36.6491 51.8184 32.222 55.5332C26.8735 60.0212 18.7984 59.2015 14.1857 53.7044C9.57226 48.2063 10.169 40.1117 15.5166 35.6245L15.5164 35.6263ZM19.8948 40.8442C22.4404 38.7082 26.2816 39.0987 28.4763 41.7143C30.6711 44.3299 30.3875 48.1816 27.8431 50.3166C25.2987 52.4516 21.4563 52.062 19.2615 49.4465C17.0668 46.8309 17.3503 42.9792 19.8948 40.8442Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentions);
export default __webpack_public_path__ + "static/media/Mentions.a4282c77.svg";
export { ForwardRef as ReactComponent };